<script>
export let errors
export let field
</script>

{#if $errors && $errors[field] }
<div class="error">{$errors[field]}</div>
{/if}
